module.exports = __webpack_public_path__ + "static/img/cxk.048a03b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cxk.png
// module id = VFD/
// module chunks = 1